var badge = {
  sizes: {
    xSmall: {
      minWidth: 10,
      height: 10
    },
    small: {
      minWidth: 13,
      height: 13
    },
    medium: {
      minWidth: 16,
      height: 16
    },
    large: {
      minWidth: 22,
      height: 22
    },
    xLarge: {
      minWidth: 28,
      height: 28
    }
  }
};
export default badge;